import React from 'react';
import { Table, Button, Input, Icon, Card, Dropdown, Menu, Modal, message, Popconfirm } from 'antd';
import common from '../../assets/common.js';
import MenuAction from '../../modest/menuaction/index.js'
import './index.css';

let init = null;
class MemberTable extends React.Component {
  delete = (record) => {
    var postData = {};
    postData["_url"] = "";
    postData["_method"] = "DELETE";
    postData["id"] = record.id;
    common.request(postData, this, function(obj, result){
      const pagination = obj.state.table.pagination;
      obj.getList(pagination);
    });
  }
  cancel = (id) =>{
    console.log(id)
  }
  constructor(){
    super();
    let table = {};
    table.id = "proTable";
    table = common.getDefaultTable(table);
    this.state = {
      table,
      batchList : [],
      search : "",
      modalType : "",
      modalData : "",
      visible: false,
      visibleApp: false,
      pwdUrl:"",
      passWDInfo: "",
      record: ''
    }
  }
  componentWillMount(){
    this.showTableCol();
  }
  componentDidMount(){
    this.getList();
  }
  showTableCol = () => {
    let table = this.state.table;
    table.columnsList = [{
      title: '简码',
      dataIndex: 'orgId',
      must: true,
      show: true,
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
        <div className="custom-filter-dropdown">
          <Input
            ref={ele => this.searchInput = ele}
            placeholder="请输入简码"
            value={selectedKeys[0]}
            onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
            onPressEnter={this.handleSearch(selectedKeys, confirm)}
          />
          <Button type="primary" onClick={this.handleSearch(selectedKeys, confirm)}>搜索</Button>
          <Button onClick={this.handleReset(clearFilters)}>重置</Button>
        </div>
      ),
      filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#108ee9' : '#aaa' }} />,
      onFilter: (value, record) => record.orgId.toLowerCase().includes(value.toLowerCase()),
      onFilterDropdownVisibleChange: (visible) => {
        if (visible) {
          setTimeout(() => {
            this.searchInput.focus();
          });
        }
      },
      render: (text) => {
        const { searchText } = this.state;
        return searchText ? (
          <span>
            {text.split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')).map((fragment, i) => (
              fragment.toLowerCase() === searchText.toLowerCase()
                ? <span key={i} className="highlight">{fragment}</span> : fragment // eslint-disable-line
            ))}
          </span>
        ) : text;
      },
    }, {
      title: '学校全称',
      dataIndex: 'orgName',
      must: false,
      show: true,
    },{
      title: '宇泛信息',
      dataIndex: 'action',
      must: false,
      show: true,
      render: (text, record) => {
        return (
          <a onClick={this.check.bind(this, record)}>查看</a>
        )
      }
    },{
      title: '管理员账号',
      dataIndex: 'userName',
      must: true,
      show: true,
      width : "150px"
    }, {
      title:'操作',
      key:"action",
      must: true,
      show: true,
      width: "120px",
      render: (text, record)=>{
        const menu = (
          <Menu>
            <Menu.Item>
              <a target="_blank" rel="noopener noreferrer" onClick={()=> this.getCode(record)}>查看密码</a>
            </Menu.Item>
            <Menu.Item>
              <a target="_blank" rel="noopener noreferrer" onClick={()=> this.returnAdd(record)}>修改</a>
            </Menu.Item>
            <Menu.Item>
            <Popconfirm title="确定切换到该学校？" okText="是" cancelText="否" onConfirm={() => this.goOneSchool(record.adminId)}>
              <a className="wrap">切换到该学校</a>
            </Popconfirm>
            </Menu.Item>
          </Menu>
        );
        return(
          <Dropdown overlay={menu}>
            <div className="ant-dropdown-link">
            更多<Icon type="down" />
            </div>
          </Dropdown>
        )
      }
    }];
    table = common.getEcardTable(table);
    // console.log(table);
    this.setState({ table });
  }
  changePage = (pagination, filters, sorter) => {
    const table = this.state.table;
    table.pagination = pagination;
    this.setState({ table })
  }
  getList = (pageInfo, filters, sorter) =>{
    const pn = pageInfo ? 1 : pageInfo
    const batchId = this.state.batchId;
    const table = this.state.table;
    var postData = {};
    postData["_url"] = "api/organization/list";
    postData["_method"] = "GET";
    postData["batch_id"] = batchId;
    table.loading = true;
    this.setState({ table });
    common.request(postData, this, function(obj, data){
      const result = data.result;
      obj.showList(result, pn);
    },function(obj, state){
      table.loading = false;
      obj.setState({ table });
    });
  }
  showList = (result, pn) => {
    const table = this.state.table;
    const list = result.list;
    table.loading = false;
    var dataSource = [];
    table.pagination = {
      current : pn,
      total : result.pageInfo.resultAmount,
    }
    common.eachObj(list, function(index, dataItem){
      var one = dataItem;
      one["key"] = (index + 1);
      one["orgId"] = dataItem.orgId;
      one["orgName"]= dataItem.orgName;
      one["userName"] = dataItem.userName;
      dataSource.push(one);
    })
    table.dataSource = dataSource;
    this.setState({ table });
  }
  showModal = (modalType, modalData) => {
    switch(modalType){
      case "releaseend":case "importend":
        this.getList();
        this.setState({ modalType, modalData });
        break;
      default:
        this.setState({ modalType, modalData });
        break;
    }
  }
  handleSearch = (selectedKeys, confirm) => () => {
    confirm();
    this.setState({ searchText: selectedKeys[0] });
  }

  handleReset = clearFilters => () => {
    clearFilters();
    this.setState({ searchText: '' });
  }
  changeBatch = (batchId) => {
    this.setState({ batchId }, function(){
      this.getList()
    })
  }
  //获取查看密码code
  getCode = (record)=> {
    let postData = {};
    postData["_url"] = 'api/admin/code';
    postData["_method"] = 'GET';
    common.request(postData, this, function(obj, result){
      obj.setState({
        code: result.result,
        visible: true,
        orgName: record.orgName,
        pwdUrl: window.location.protocol+'//'+window.location.host+"/acs/api/admin/pwdcode/"+ record.orgId +"/img?id=" + result.result,
      });
      obj.setInt(record.orgId);
    },function(obj, data){
      message.warning(data.message);
    });
  }
  // 切换学校
  goOneSchool = (adminId) => {
    fetch("api/admin/switch",{
      credentials: 'same-origin',//'include'
      method: 'POST',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      },
      body: "adminId=" + adminId,
    }).then(response => response.json())
    .then(data => {
      if(data.status === "200" || data.status === 200){
        window.location.href = window.location.origin + window.location.pathname + '#/manage/user'; //window.location.protocol+'//'+window.location.host+'/wlxy/admin/home.html';
        window.location.reload();
      } else {
        message.warning(data.message);
      }
    });
  }
  check = (record) => {
    this.setState({
      visibleApp: true
    });
    this.getDetail(record);
  }
  handleCancel = ()=> {
    this.setState({
      visible: false
    });
    clearInterval(init);
  }
  handleCancelApp = ()=> {
    this.setState({
      visibleApp: false
    });
  }
  getDetail = (record) => {
    let postData = {};
    let _method = 'GET';
    postData["_url"] = 'api/organization/detail';
    postData["_method"] = _method;
    postData["id"] = record.id;// values.orgLogo.file.response.result;
    common.request(postData, this, function(obj, result){
      obj.setState({
        record: result.result
      })
    },function(obj, data){
      message.warning(data.message);
    });
  }
  // 获取扫码状态
  getCodeStatus = (orgId) => {
    let postData = {};
    postData["_url"] = 'api/admin/code/status';
    postData["orgId"] = orgId;
    postData["code"] = this.state.code;
    common.request(postData, this, function(obj, result){
      obj.setState({
        passWDInfo: result.result
      });
      if(result.result.status === "SUCCESS") {
        clearInterval(init);
      }
    },function(obj, data){
      message.warning(data.message);
    });
  }
  // 循环调用查看扫码状态
  setInt = (orgId)=> {
    let this_ = this;
    init = setInterval(()=>{
      this_.getCodeStatus(orgId);
    }, 1000)
  }
  returnAdd = (record) => {
    if(record) {
      sessionStorage.setItem("record", JSON.stringify(record));
    } else {
      sessionStorage.removeItem('record');
    }
    window.location.href = "#/school/add";
  }
  render(){
    const { table, passWDInfo, record } = this.state;
    const pswtitle = "请用支付宝扫码查看"+ this.state.orgName +"的密码";
    return(
      <Card>
        <div>
          <Button type="primary" onClick={() => this.returnAdd('')}><Icon type="plus" />新增学校</Button>
          <div className="table-menu clearfix">
            <div className="pull-right">
            { table.show && <MenuAction obj={ this }/> }
            </div>
          </div>
          <div id="manageTableDiv" className="table-div">
            { table.show && <Table
              { ...table }
              onChange={this.changePage.bind(this)}
            />}
            <div className="table-total">共{ table.pagination.total }条数据</div>
          </div>
          <Modal
            title="查看密码"
            visible={this.state.visibleApp}
            centered={true}
            className="text-center"
            onCancel={this.handleCancelApp}
            footer={[
              <Button onClick={this.handleCancelApp}>关闭</Button>
            ]}
          >
            <div>宇泛人脸AppId：{record && record.uface?record.uface.appId:'无'}</div>
            <div>宇泛人脸AppKey：{record && record.uface?record.uface.appKey:'无'}</div>
            <div>宇泛人脸AppSecret：{record && record.uface?record.uface.appSecret:'无'}</div>
          </Modal>
          <Modal
            title="查看密码"
            visible={this.state.visible}
            centered={true}
            className="text-center"
            onCancel={this.handleCancel}
            footer={[
              <Button onClick={this.handleCancel}>关闭</Button>
            ]}
          >
            <div style={{textAlign: 'center'}}>
              <div id="pswtitle">{pswtitle}</div>
              {
                passWDInfo&&passWDInfo.status === "SUCCESS" ?
                <div id="pswDiv">
                  <div>账号：{passWDInfo.userName}</div>
                  <div>密码：{passWDInfo.passWord}</div>
                </div> :
                <img src={this.state.pwdUrl} width="175px"/>
              }
            </div>
          </Modal>
        </div>
      </Card>
    )
  }
}
export default MemberTable;



// WEBPACK FOOTER //
// ./src/component/school/list.js